import { SelectorItems } from '../components/CampaignAndGroupSelector/Selector/Selector';
import { CampaignDayBudgetParams } from '../typings/budget';
import { CellKeyFieldsPartial } from '../typings/common';
import { CampaignAndGroupSelectorEntityToSelectType } from '../typings/sidebar';

export const UPDATE_CAMPAIGN_DAY_BUDGET_INFO_REMOTE = 'UPDATE_CAMPAIGN_DAY_BUDGET_INFO_REMOTE';
export type UPDATE_CAMPAIGN_DAY_BUDGET_INFO_REMOTE = typeof UPDATE_CAMPAIGN_DAY_BUDGET_INFO_REMOTE;

export interface UpdateCampaignDayBudgetInfoRemoteAction {
    type: UPDATE_CAMPAIGN_DAY_BUDGET_INFO_REMOTE;
    params: CampaignDayBudgetParams;
    login: string;
    cellKeyPartial: CellKeyFieldsPartial;
}

export function updateCampaignDayBudgetInfoRemote(
    params: CampaignDayBudgetParams,
    login: string,
    columnName?: string
): UpdateCampaignDayBudgetInfoRemoteAction {
    return {
        type: UPDATE_CAMPAIGN_DAY_BUDGET_INFO_REMOTE,
        params,
        login,
        cellKeyPartial: {
            id: params.campaignId,
            column: columnName
        }
    };
}

export const ADD_GROUP_CAMPAIGN_GRID = 'ADD_GROUP_CAMPAIGN_GRID';
export type ADD_GROUP_CAMPAIGN_GRID = typeof ADD_GROUP_CAMPAIGN_GRID;

export interface AddGroupCampaignGridAction {
    type: ADD_GROUP_CAMPAIGN_GRID;
    campaign: SelectorItems;
    entityToSelectType: CampaignAndGroupSelectorEntityToSelectType;
}

export function addGroupCampaignGrid(
    campaign: SelectorItems,
    entityToSelectType: CampaignAndGroupSelectorEntityToSelectType
): AddGroupCampaignGridAction {
    return {
        type: ADD_GROUP_CAMPAIGN_GRID,
        campaign,
        entityToSelectType
    };
}

export type CampaignGridAction = UpdateCampaignDayBudgetInfoRemoteAction | AddGroupCampaignGridAction;
